import { useClubSlug } from "components/Clubs/hooks";
import { Form } from "components/Form/base/Form";
import { FormInput } from "components/Form/next";
import { Placeholder } from "components/Form/next/FormWYSIWYG";
import Loader from "components/Loader";
import { useDownload } from "hooks";
import { useApi } from "../../../hooks/useApi";
import Joi from "joi";
import { useState } from "react";
import useSWR from "swr";
import { addressSchema } from "validation/schema/addressSchema";

type RecipientType = "club-member";
interface Props {
    letterId?: number;
    placeholders?: Placeholder[];
    recipientType?: RecipientType;
    recipientId?: number;
    callback?: () => void;
}

export const LetterForm = ({
    letterId,
    placeholders = [],
    recipientId,
    recipientType = "club-member",
    callback,
}: Props) => {
    const clubSlug = useClubSlug();
    const { data, error } = useSWR(letterId ? `letter/${letterId}` : null);
    const letter = data?.data || {};
    const api = useApi();
    const download = useDownload();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: letterId ? `letter/${letterId}` : `club/${clubSlug}/letter`,
            method: letterId ? "PUT" : "POST",
            data: { recipientId, recipientType, ...data },
            responseType: "blob",
            onBefore: () => setIsLoading(false),
            onSuccess: (data) => {
                download(data, "letter.pdf");
                callback?.();
            },
        });
    };

    // const schema = Joi.object({
    //     date: Joi.date().required().label("Datum des Briefes"),
    //     subject: Joi.string().max(255).label("Betreff"),
    //     message: Joi.string().required().label("Nachricht"),
    //     ...addressSchema,
    // });

    return (
        <Loader isLoading={letterId && !data && !error}>
            <Form onSubmit={handleSubmit} setDefaultValuesOnRerender={false} defaultValues={{ ...letter }}>
                <FormInput.DatePicker name="date" label="Datum des Briefes" />
                <FormInput name="subject" label="Betreff" />

                <FormInput.WYSIWYG placeholders={placeholders} name="message" label="Nachricht" />
                <FormInput.Submit isLoading={isLoading}>Speichern und herunterladen</FormInput.Submit>
            </Form>
        </Loader>
    );
};
